import React, {useState, useEffect} from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { Helmet } from 'react-helmet-async';

import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';
import ConteudoPrincipal from './Sections/conteudo-principal';
import NoticiasRelacionadas from './Sections/noticias-relacionadas';
import { PostInterface } from '../../Services/types';
import { fetchData } from '../../../Api';

const IntegraBlog: React.FC<any> = ({initialData} : any) => {
    function processPost()
    {
        if (initialData == null) return null;

        let post_form = initialData.post;
        post_form.data = new Date(post_form.data);
        return post_form;
    }

    function processPosts()
    {
        if (initialData == null) return [];

        const formattedPosts = initialData.posts.map((post: PostInterface) => ({
            ...post,
            data: new Date(post.data),
        }));
        return formattedPosts;
    }

    const { news } = useParams<{ news: string }>();
    const [post, setPost] = useState<PostInterface | null>(processPost());
    const [posts, setPosts] = useState<PostInterface[]>(processPosts());
    const location = useLocation();
    const url = 'https://uniexpo.com.br' + location.pathname + location.search; 

    useEffect(() => {    
        if (!news || news == post?.slug) return;
        const loadData = async () => {
            const response = await fetchData(`noticias/${news}`);
            if(response){
                if (response.post) {
                    let post_form = response.post;
                    post_form.data = new Date(post_form.data);
                    setPost(post_form);
                }
                if (response.posts) {
                    const formattedPosts = response.posts.map((post: PostInterface) => ({
                        ...post,
                        data: new Date(post.data),
                    }));
                    setPosts(formattedPosts);
                }
            }
        };  
        loadData();
    }, [news]);
    //const post = posts.find((post) => post.slug === news);

    const title = post?.titulo;

    const descFormat = (html: string, maxLength = 150): string => {
        const plainText = html.replace(/<[^>]*>/g, '');
      
        return plainText.length > maxLength
          ? plainText.slice(0, maxLength).trim() + '...'
          : plainText;
    };
 
    const breadcrumb = [{
        name: 'Blog',
        slug: 'blog'
    }];
    
    return (
        <>
            {post &&
                <Helmet>
                    <title>{title} - Uniexpo</title>
                    <meta name="description" content={post.yoast_desc || descFormat(post.content) || ''} />

                    <meta property="og:type" content="website" />
                    <meta property="og:url" content={url} />
                    <meta property="og:description" content={post.yoast_desc || descFormat(post.content) || ''} />
                    <meta property="og:image" content={post.thumbnail || ''} />
                    <meta property="og:image:secure_url" content={post.thumbnail || ''} />
                    <meta property="og:image:type" content="image/jpeg" />
                    <meta property="og:title" content={(title || '') + ' - Uniexpo'} />
                    <meta property="og:site_name" content="Uniexpo" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={(title || '') + ' - Uniexpo'} />
                    <meta property="twitter:description" content={post.yoast_desc || descFormat(post.content) || ''} />
                    <meta name="twitter:image" content={post.thumbnail || ''} />
                </Helmet>
            }

            <MainLayout desc>
                <Header title="Blog" breadcrumb={breadcrumb} />
                {post && (
                    <ConteudoPrincipal post={post} />
                )}
                {posts && (
                    <NoticiasRelacionadas posts={posts}/>
                )}
            </ MainLayout>
        </>
    );
};

export default IntegraBlog;
